<template>
  <div class="goods-tabs-body-product-down">
    <!-- <div class="goods-tabs-body-product-down-line" v-for="(item,index) in goods.list">
            <div class="goods-tabs-body-product-down-left">
                <i class="icon iconfont" :class="{'icon-zip1':getType(item.name),'icon-pdf':!getType(item.name)}"></i>
                <span>{{item.name}}</span>
            </div>
            <div class="goods-tabs-body-product-down-right">
                <a :href="item.url" target="_blank">下载</a>
            </div>
        </div> -->

    <div class="down-contents">
      <div class="down-contents-title">本机下载资料</div>
    </div>
    <div
      class="goods-tabs-body-product-down-line"
      v-for="(item, index) in goods.list"
    >
      <div class="goods-tabs-body-product-down-left">
        <i
          class="icon iconfont"
          :class="{
            'icon-zip1': getType(item.name),
            'icon-pdf': !getType(item.name),
          }"
        ></i>
        <span>{{ item.name }}</span>
      </div>
      <div class="goods-tabs-body-product-down-right">
        <a :href="item.url" target="_blank">下载</a>
      </div>
    </div>
    <div class="down-contents pipei" v-if="getMNameShow()">
      <div class="down-contents-title">推荐匹配{{ getMName() }}</div>
    </div>
    <div class="relation-table" v-if="matchList.length > 0 &&goodsId!=104">
      <div class="table-tr">
        <div class="table-th th1">品牌</div>
        <div class="table-th th2">型号</div>
        <div class="table-th th3">选型手册下载</div>
        <div class="table-th th4">{{ getMName() }}三维下载</div>
      </div>
      <div
        class="table-tr table-contents"
        v-for="(match, index) in matchList"
        :key="index"
        :class="{ 'talbe-type': (index + 1) % 2 == 0 }"
      >
        <div class="table-td th1">{{ match.brand }}</div>
        <div class="table-td th2">
          <ul class="match">
            <li
              v-for="(sitem, iindex) in match.list"
              :key="iindex"
              :class="{ haveurl: match.brand == '清能德创' }"
              @click="goto(sitem.tomodel)"
            >
              {{ sitem.tomodel }}
            </li>
          </ul>
        </div>
        <div class="table-td th3">
          <p v-if="match.chd">
            <a target="_blank" :href="match.chd">中文版下载</a>
          </p>
          <p v-if="match.end">
            <a target="_blank" :href="match.end">英文版下载</a>
          </p>
        </div>
        <div class="table-td th4">
          <ul>
            <li v-for="(item, iindex) in match.list" :key="iindex">
              <a
                target="_blank"
                :href="item.downUrl"
                :title="item.downName ? item.downName : item.tomodel"
                >下载</a
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="table-tr table-contents talbe-type">
        <div class="table-td th1">清能德创</div>
        <div class="table-td th2">
          <ul>
            <li>TDA130-14320FA1-01B00</li>
          </ul>
        </div>
        <div class="table-td th3">
          <p>中文版下载</p>
          <p>中文版下载</p>
        </div>
        <div class="table-td th4">
          <ul>
            <li>下载</li>
          </ul>
        </div>
      </div> -->
    </div>
    <div v-if="goodsId==104" class="relation-table">
      <GoodsDownItem @goto="goto"></GoodsDownItem>
    </div>
    

    <!-- <img
      v-if="classId == 12"
      class="goods-tabs-body-product-down-img"
      src="/static/goods/down.jpg"
    /> -->
  </div>
</template>

<script>
import GoodsDownItem from './GoodsDownItem.vue';
export default {
    data() {
        return {
            matchList: [],
        };
    },
    methods: {
        getType(val) {
            return (this.$FUnitls.matchType(val) == "zip" ||
                this.$FUnitls.matchType(val) == "tar" ||
                this.$FUnitls.matchType(val) == "rar");
        },
        getDownList() {
            var info = {};
            info.id = this.goodsId;
            this.$api.goods.getDownList(info).then((res) => {
                this.matchList = res.data.datas;
            });
        },
        getMName() {
           if(this.goodsId==104){
            return "电机";
           }
            if (this.matchList[0].type == 1) {
                return "驱动器";
            }
            else {
                return "电机";
            }
        },
        getMNameShow(){
          return this.matchList.length > 0 || this.goodsId==104
        },
        goto(val) {
            this.$api.goods.getSearch(val, "", 1).then((res) => {
                if (res.data.datas.data.length > 0) {
                    var index = res.data.datas.data.findIndex((item) => {
                        if (item.model == val) {
                            return true;
                        }
                    });
                    if (index == -1) {
                        index = 0;
                    }
                    this.$router.push({
                        name: "goodsinfo",
                        params: { goodsid: res.data.datas.data[index].id },
                    });
                }
            });
        },
    },
    mounted() {
        this.getDownList();
    },
    // computed:{
    //     getType(){
    //         return this.$FUnitls.matchType("ssf/sdfs/asdf/sdfs.zip")
    //     }
    // },
    props: ["goods", "classId", "goodsId"],
    components: { GoodsDownItem }
};
</script>

<style scoped>
.goods-tabs-body-product-down-img {
  width: 100%;
  margin-top: 45px;
}
.goods-tabs-body-product-down-left .icon {
  color: #2655ae;
  font-size: 22px;
}
.goods-tabs-body-product-down-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 0;
  border-left: 1px solid #e6e6e6;
  width: 1140px;
  margin: 0 auto;
}
.goods-tabs-body-product-down-left {
  display: flex;
  align-items: center;
  margin-left: 30px;
}
.goods-tabs-body-product-down-left span {
  margin-left: 20px;
}
.goods-tabs-body-product-down-right {
  width: 144px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
}
.goods-tabs-body-product-down-right a {
  color: #666666;
  /* padding-bottom: 5px; */
  /* border-bottom: 1px solid #2655ae; */
}
.goods-tabs-body-product-down-right a:hover {
  cursor: pointer;
  color: #2655ae;
  text-decoration: underline;
}

.goods-tabs-body-product-down {
  padding-bottom: 50px;
  background-color: #fff;
  min-height: 600px;
  overflow: hidden;
}
.down-contents {
  width: 1140px;
  margin: 0 auto;
  margin-top: 30px;
  height: 49px;
  line-height: 49px;
  background-color: #2655ad;
}
.down-contents.pipei {
  margin-top: 0;
}
.down-contents-title {
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  margin-left: 30px;
  position: relative;
  padding-left: 11px;
}
.down-contents-title::before {
  position: absolute;
  content: " ";
  left: 0;
  top: 16px;
  width: 3px;
  height: 17px;
  background-color: #fff;
}

.relation-table {
  width: 1140px;
  margin: 0 auto;
  border-top: 1px solid #cccccc;
  box-sizing: border-box;
}
.relation-table .table-tr {
  background-color: #2655ae;
  color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: row;
}
.relation-table .table-tr div {
  float: left;
  text-align: center;
  border-right: 1px solid #cccccc;
}
.relation-table .table-tr div:last-child {
  border: none;
}
.relation-table .table-tr .th1 {
  width: 200px;
}
.relation-table .table-tr .th2 {
  width: 500px;
}
.relation-table .table-tr .th3 {
  display: flex;
  flex-direction: column;
  width: 299px;
}
.relation-table .table-tr .th4 {
  width: 143px;
}
.table-th {
  height: 37px;
  line-height: 37px;
}
.table-tr .table-td {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  color: #666666;
}

.table-tr .table-td a {
  color: #666666;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
.table-tr .table-td a:hover,
.table-tr .table-td .haveurl:hover {
  cursor: pointer;
  color: #2655ae;
  text-decoration: underline;
}
.table-tr {
  border-left: 1px solid #2655ae;
  border-right: 1px solid #2655ae;
}
.table-tr.table-contents {
  border-left: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
  box-sizing: border-box;
  border-bottom: 1px solid #cccccc;
}
.table-tr .th2 ul li,
.table-tr .th4 ul li {
  display: inline-block;
  height: 48px;
  line-height: 48px;
  width: 100%;
  border-bottom: 1px solid #cccccc;
}
.table-tr .th2 ul {
  width: 497px;
}
.table-tr .th2 ul li:last-child,
.table-tr .th4 ul li:last-child {
  border: none;
}
.table-tr .th4 ul {
  width: 142px;
}
.table-tr .th3 p {
  width: 100%;
  line-height: 40px;
}
.relation-table .talbe-type .table-td {
  background-color: #e8f1ff;
}
</style>


// WEBPACK FOOTER //
// src/components/goods/GoodsDown.vue